import { Toaster, toast } from 'vue-sonner'

export default defineNuxtPlugin({
  name: 'toast',
  parallel: true,
  setup(nuxtApp) {
    nuxtApp.vueApp.component('Toaster', Toaster)

    return {
      provide: {
        toast,
      },
    }
  }
})
